import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "back",
  "use": "back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"back\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 24.213l21.213 21.213 2.829-2.829-21.213-21.213L12 24.214z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M33.212 3L12 24.213l2.83 2.83L36.041 5.827 33.214 3h-.002z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol